import { render } from "./kalio-job-offer-form.vue?vue&type=template&id=27bddc6d"
import script from "./kalio-job-offer-form.vue?vue&type=script&lang=js"
export * from "./kalio-job-offer-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__